class MassageModel{
  constructor(id,userid,nof,type,date,userImg,userName,unread,story){
    this.id = id;
    this.userid = userid;
    this.nof = nof;
    this.type = type;
    this.date = date;
    this.userImg = userImg;
    this.userName = userName;
    this.unread = unread || 0;
    this.story = story;
  }
}

export default MassageModel;
